import React              from 'react';
import { useTranslation } from 'react-i18next';
import RenderButton       from './base/RenderButton';
import { useShare }       from '../../providers/share';
import shareConstants     from '../../providers/share/share.constants';

const Share = (props) => {
  const { t }         = useTranslation();
  const { showModal } = useShare();

  const { getLink } = props;

  return (
    <RenderButton
      action={() => {
        showModal(shareConstants.SHOW_MODAL);
        getLink();
      }}
      label={t('btn_share_selection')}
      className={'fill'}
    />
  );
};

export default Share;